<nz-form-control>
  <nz-select
    [ngModel]="value"
    (ngModelChange)="onValueChange($event)"
    [nzClearIcon]="customClearIcon"
    [nzSuffixIcon]="customSelectIcon"
    [nzAllowClear]="nzAllowClear"
    nzSize="large"
    nzShowSearch
    (nzOnSearch)="onSearch($event)"
    [nzDisabled]="disabled"
    [nzPlaceHolder]="placeholder"
    [nzStatus]="nzStatus || ''"
    [nzLoading]="nzLoading"
  >
    @if (noneLabel) {
      <nz-option [nzValue]="noneValue" [nzLabel]="noneLabel"></nz-option>
    }

    @if (options) {
      <nz-option
        *ngFor="let item of options"
        [nzValue]="getOptionValue(item)"
        [nzLabel]="getOptionLabel(item)"
      ></nz-option>
    }

    @if (allowCreateNew && !disabled) {
      <nz-option [nzValue]="'CREATE_NEW'" [nzLabel]="createLabel + ' ' + createNewSearchText" nzCustomContent>
        <div class="master-create-option" (click)="onCreateNewClick($event)">
          <app-st-icon name="add"></app-st-icon>
          <span>{{ createLabel }} {{ createNewSearchText }}</span>
        </div>
      </nz-option>
    }
  </nz-select>
</nz-form-control>

<ng-template #customClearIcon>
  <app-st-icon class="custom-clear" name="close"></app-st-icon>
</ng-template>

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>

<ng-template #notificationTmpl>
  <app-toast
    [notRef]="notRef!"
    [icon]="toastConfig.icon"
    [iconColor]="toastConfig.iconColor"
    [content]="toastConfig.content"
    [msg]="toastConfig.msg"
    [showUndo]="toastConfig.showUndo"
  ></app-toast>
</ng-template>
